/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams, useNavigate } from 'react-router-dom'

import { RiLockPasswordFill } from "react-icons/ri";
import { FaUser, FaUserCheck } from "react-icons/fa";
import { FiEye, FiEyeOff } from "react-icons/fi";

import { customer_reset_password, messageClear } from '../store/reducers/authReducer';

import Header from '../components/Header';
import Footer from '../components/Footer';
import GetSellerConfig from '../components/GetSellerConfig';

import toast from 'react-hot-toast';
import config from '../config';

const ResetPassword = () => {
    const sellerFrontendURL = config.STR_FRONTEND_URL
    const sellerDashboardURL = config.STR_DASHBOARD_URL

    //const { seller } = useSelector(state => state.seller)
    const { loader, errorMessage, successMessage, userInfo } = useSelector(state => state.auth);
    const {customerId} = useParams()
      const { 
        sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
        sellerShopName, sellerStripePaymentMode, sellerOtherWebsiteURL1, sellerOtherWebsiteName1, 
        sellerOtherWebsiteURL2, sellerOtherWebsiteName2, sellerProductTerm, sellerProductPluralTerm,
        sellerCompanyPhoneNumber, sellerCompanyLogo,sellerSellerImage, sellerBeforeYouRegister1, sellerPhoneNumber,
        sellerCompanyEmailAddress, sellerCompanyKosherSupervision1, 
        sellerCompanyKosherSupervision2, sellerMainIngredientPluralTerm, sellerTaglineTop1, sellerTaglineTop2, 
        personalServiceTagLine, sellerMarketingLine1, sellerHolidayHeader, sellerOwnerNames,
        sellerBoolShowSiteWishList, sellerBoolShowSiteChat, sellerBoolShowGalleryImages, sellerBoolShowSocialMedia
    } = GetSellerConfig();
  
    // const sellerId = seller._id 
    // const sellerPrimaryColor1 = seller.frontEndPrimaryColor1
    // const sellerSecondaryColor1 = seller.frontEndSecondaryColor1
    //console.log('sellerId', sellerId)

    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const [state, setState] = useState({
        webSiteOrigin: sellerFrontendURL, password: '', confirmPassword: '', customerId: customerId
    });

    const [showPassword, setShowPassword] = useState(false);
    const handleShowPasswordToggle = (e) => {
        setShowPassword(!showPassword);
    }
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const handleShowConfirmPasswordToggle = (e) => {
        setShowConfirmPassword(!showConfirmPassword);
    }

    const inputHandle = (e) => {
        setState({
            ...state,
            [e.target.name]: e.target.value
        });
        //console.log('state', state)
    };
    const customer_reset_password_local = (e) => {
        e.preventDefault();
        //console.log('state', state)
        dispatch(customer_reset_password(state));
    };
     
    useEffect(() => {
        if (errorMessage) {
            toast.error(errorMessage);
            dispatch(messageClear());
        }
        if (successMessage) {
            toast.success(successMessage);
            dispatch(messageClear());
            navigate('/login')
        }
    }, [errorMessage, successMessage]);

    return (
        <div>
            <Header />
            <div className='min-w-screen bg-slate-200 flex justify-center items-center' >
                <div className='w-[350px] h-[270px] items-center m-8 flex justify-center'>
                    <div className='bg-white text-[#ffffff] p-4 rounded-md shadow-lg'>
                        <form onSubmit={customer_reset_password_local} className=''>
                            <div className='text-center text-xl font-bold' style={{ color: sellerPrimaryColor1 }}>
                                Reset Password
                            </div>
                            <div className='flex flex-col w-full gap-1 mb-3' style={{ color: sellerPrimaryColor1 }}>
                                <label htmlFor="email">New Password</label>
                                <div className='flex items-center' style={{ position: 'relative', width: '100%' }}>
                                    <input onChange={inputHandle} value={state.password} 
                                        className='hide-ms-reveal px-3 py-2 w-full outline-none border border-slate-400 bg-transparent rounded-md' 
                                        type={showPassword ? 'text' : 'password'}  name='password' placeholder='New Password' id='password' required />
                                    <span onClick={handleShowPasswordToggle}
                                        style={{position: 'absolute',  right: '10px', top: '50%', transform: 'translateY(-50%)',
                                        cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                                        {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                                    </span>
                                </div>
                            </div>
                            <div className='flex flex-col w-full gap-1 mb-3' style={{ color: sellerPrimaryColor1 }}>
                                <label htmlFor="email">Confirm Password</label>
                                <div className='flex items-center' style={{ position: 'relative', width: '100%' }}>
                                    <input onChange={inputHandle} value={state.confirmPassword} 
                                        className='hide-ms-reveal px-3 py-2 w-full outline-none border border-slate-400 bg-transparent rounded-md' 
                                        type={showConfirmPassword ? 'text' : 'password'} name='confirmPassword' placeholder='Confirm Password' id='confirmPassword' required />
                                    <span onClick={handleShowConfirmPasswordToggle}
                                        style={{position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)',
                                        cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                                        {showConfirmPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                                    </span>
                                </div>
                            </div>
                            {
                                state.password !== state.confirmPassword &&
                                <div className='text-red-500 text-sm mb-2'>
                                    Passwords do not match.
                                </div>
                            }
                            <button disabled={state.password !== state.confirmPassword} visibility={state.password !== state.confirmPassword ? 'hidden' : 'visible'}
                                className='flex mb-3 justify-center px-8 w-full py-2 shadow-lg hover:shadow-green-500/40 text-white rounded-md'
                                style={{ backgroundColor: sellerPrimaryColor1 }}>
                                <RiLockPasswordFill className='mr-2 text-[20px]' /> Reset My Password
                            </button>
                        </form>
                    </div>
                </div>  
            </div>
            <Footer />
        </div>
    );
};

export default ResetPassword;
